import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


const Carousel = () => {
    return (
        <>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                loop={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="mySwiper z-[-0]"
            >
                <SwiperSlide>
                    <img src='https://res.cloudinary.com/dnivqqmqv/image/upload/q_auto/f_auto/v1779561218/collage_rny98j.png' alt="banner" className='w-full lg:h-[548px] h-[200px]'  onContextMenu={(e) => e.preventDefault()} draggable="false" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src='https://res.cloudinary.com/dnivqqmqv/image/upload/q_auto/f_auto/v1779561353/food-distribution_tiqst6.jpg' alt="" className='w-full lg:h-[548px] h-[200px]'  onContextMenu={(e) => e.preventDefault()} draggable="false"/>
                </SwiperSlide>
                <SwiperSlide>
                    <img src='https://res.cloudinary.com/dnivqqmqv/image/upload/q_auto/f_auto/v1779425050/cow_vnyiml.png' alt="qurbani" className='w-full lg:h-[548px] h-[200px]'  onContextMenu={(e) => e.preventDefault()} draggable="false"/>
                </SwiperSlide>
                <SwiperSlide>
                    <img src='https://res.cloudinary.com/dnivqqmqv/image/upload/q_auto/f_auto/v1779425194/gaza_sps34t.jpg' alt="gaza water distribution" className='w-full lg:h-[548px] h-[200px]'  onContextMenu={(e) => e.preventDefault()} draggable="false"/>
                </SwiperSlide>
                <SwiperSlide>
                    <img src='https://res.cloudinary.com/dnivqqmqv/image/upload/q_auto/f_auto/v1779425336/corona_dfvvhj.png' alt="covid" className='w-full lg:h-[548px] h-[200px]'  onContextMenu={(e) => e.preventDefault()}draggable="false"/>
                </SwiperSlide>
                <SwiperSlide>
                    <img src='https://res.cloudinary.com/dnivqqmqv/image/upload/q_auto/f_auto/v1779425478/medical_jdhtpq.jpg' alt="treatment" className='w-full lg:h-[548px] h-[200px]'  onContextMenu={(e) => e.preventDefault()} draggable="false"/>
                </SwiperSlide>
                <SwiperSlide>
                    <img src='https://res.cloudinary.com/dnivqqmqv/image/upload/q_auto/f_auto/v1779425569/chairman_heycfy.png' alt="chairman" className='w-full lg:h-[548px] h-[200px]'  onContextMenu={(e) => e.preventDefault()} draggable="false"/>
                </SwiperSlide>
            </Swiper>
        </>
    );
};

export default Carousel;